import i18n from '@i18n';
import UserService from '@services/user'
import {useUserStore} from '@store/user'

const {t} = i18n.global;
const whiteList = ['auth', 'login']; // no redirect whitelist (contains routes' names)
let authenticated = false;

export function checkAccessMiddleware(to, from, next) {
    const isUserLogged = UserService.isLogged();

    document.title = t('app_name') + ' - ' + to.meta.title;
    // console.log('checkAccessMiddleware: ', to.name, from.name);
    // console.log('useUserService isLogged'+isUserLogged);
    if (isUserLogged) {
        if (to.name === 'login') {
            // console.log('Login route:');
            // if is logged in, redirect to the home page
            next({
                name: "home",
            });
        } else {
            if (to.meta.action && to.meta.module) {
                let hasAbility = useUserStore().hasPermission(to.meta.action, to.meta.module)
                if (!hasAbility) {
                    return next({path: '/401'});
                }
            }

            /* if (to.query.redirect) {
                next({path: to.query.redirect});
            } */

            next();
        }

        return;
    }

    /* has no token*/
    if (whiteList.indexOf(to.matched[0] ? to.matched[0].name : '') !== -1) {
        // in the free login whitelist, go directly
        next();
    } else {
        // other pages that do not have permission to access are redirected to the login page.
        // next(`/dashboard/auth/login?redirect=${to.path}`);
        next({name: 'login', query: {redirect: to.path}});
    }

}
